import { enqueueSnackbar } from 'notistack'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { reset } from 'features/user'
import { RootState, store } from 'providers/redux'

export const usePreventMultipleWorkspacesBetweenTabs = (): void => {
  const { workspaceId } = useParams()
  const { user } = useSelector((state: RootState) => state.user)

  useEffect(() => {
    const interval = setInterval(() => {
      if (workspaceId === undefined) return

      if (user?.currentWorkspace?.id !== workspaceId) {
        store.dispatch(reset())
        enqueueSnackbar('Workspace ID mismatch between open browser tabs.', { variant: 'error' })
      }
    }, 5_000) // [ms]

    return () => clearInterval(interval)
  }, [workspaceId, user])
}
